/**
 * ********************************************
 * WARNING: The file named sixConfig.ts is 
 *    auto-generated by the build process. 
 *    Please edit ONLY sixConfig.template.ts
 * ********************************************
 */

import { Generic } from "./types/generic.types";

const sixConfig = {
  VERSION: "1.5.42",
  REV: "8ed87",
  BRANCH: "v2.3.4.stable_sisos",
  BASENAME: "/mso",
  APP_NAME: "MSO",
  APP_DESCRIPTION: " Monitor Sale Operatorie",
  APP_CUSTOMER: "SISOS",
} as Generic;

export default sixConfig;
